import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ebLogo from "../../../src/images/ebench_logo.png";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../Candidate/Job/ViewJob/viewJob.scss"
// import Swal from 'sweetalert2';

import { JobsDetails } from "../../Redux/action/VendorJobDetailsAction";
import BackButton from "../Common/BackButton/BackButton";
import Loader from "../Common/Loader/loader";

const JobDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const loadingData = useSelector((state) => state.VendorJobDetails.loading);  
  const applyLoading = useSelector((state) => state.ApplyJob.loading);
  const { userResult } = useSelector((state) => state.Auth);
  console.log("---", applyLoading);

  let candidateIdVal = userResult?.userid;
  let candidateId = [candidateIdVal];
  const userType = userResult?.usertype;
  const isTeamMember = localStorage.getItem("isTeamMember");
  const isTeamMemberBool = isTeamMember === "true";
  const navigate = useNavigate();

  console.log("USERTYPE===", userType);
  // console.log("ISTEAM--", Boolean(isTeamMemberBool));
  console.log("ISTEAM--", isTeamMemberBool);

  let { id } = useParams();
  let jobId = id;
  let dispatch = useDispatch();

  const location = useLocation();

  const handleCandidateId = (e, candidate) => {
    if (e.target.checked) {
      setSelectedCandidates((current) => [...current, candidate]);
    } else {
      setSelectedCandidates((current) =>
        current.filter((c) => c !== candidate)
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const userInfo = useSelector((state) => state.VendorJobDetails.result);
  let vendorid = userResult?.vendorid;

  useEffect(() => {
    dispatch(JobsDetails(id));
  }, []);

  if (loadingData) {
    return (
      <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
    )
  }

  return (
    <>
      <ToastContainer />

      <div className="vj_wrapper">
         <div className="vj_container">
           <BackButton/>
         </div>
        <div className="vj_container">
          <div className="vj_left card p-4">
            {/* <BackButton /> */}
            <div className="vj_role">
              <p>{userInfo?.jobTitle}</p>
            </div>
            <div className="line_divide"></div>

            <div className="vj_jobInfo mt-3 d-flex flex-column flex-sm-row">
              <div className="vj_info_main">
                <p className="">
                  Work Type :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.workType}
                  </span>{" "}
                </p>
                <p className="">
                  Job Type :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.employmentType == "FULL_TIME"
                      ? "Full Time"
                      : userInfo?.employmentType == "PART_TIME"
                      ? "Part Time"
                      : "Flexible"}
                  </span>{" "}
                </p>
                {userInfo?.country && (
                  <p className="">
                    Country:{" "}
                    <span className="text-secondary fw-normal">
                      {userInfo?.country || "N/A"}
                    </span>{" "}
                  </p>
                )}
                {userInfo?.state && (
                  <p className="">
                    State:{" "}
                    <span className="text-secondary fw-normal">
                      {userInfo?.state || "N/A"}
                    </span>{" "}
                  </p>
                )}
                <p style={{ marginRight: "50px" }}>
                  Experience:{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo.minimumExperience?.includes("0")
                      ? `Fresher - ${userInfo.maximumExperience
                          ?.replace(/years?/i, "")
                          ?.trim()} years`
                      : `${userInfo.minimumExperience
                          ?.replace(/years?/i, "")
                          ?.trim()} - ${userInfo.maximumExperience
                          ?.replace(/years?/i, "")
                          ?.trim()} years`}
                  </span>
                </p>

                <p className="">
                  Skills :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.requiredSkills?.join(", ")}
                  </span>{" "}
                </p>
                <p className="">
                  Working Days :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.workingDays || "N/A"}
                  </span>{" "}
                </p>
                <p className="">
                  Working Week Days :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.workingWeekDays?.join(", ") || "N/A"}
                  </span>{" "}
                </p>
                <p className="">
                  Time Zone :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.timeZone || "N/A"}
                  </span>{" "}
                </p>
              </div>
              <div style={{ minWidth: "40%" }} className="vj_info_main">
                <p className="">
                  {userInfo?.jobsPostedStatus === "POSTLATER"
                    ? "Posting On"
                    : "Posted"}{" "}
                  :{" "}
                  <span className="text-secondary fw-normal">
                    {(() => {
                      try {
                        const dateString =
                          userInfo?.jobsPostedStatus === "POSTLATER"
                            ? `${userInfo?.postLaterDate ?? ""} ${
                                userInfo?.postLaterTime ?? ""
                              }`.trim()
                            : userInfo?.postedDate ?? "";

                        if (!dateString) return "N/A";

                        const [datePart, timePart] = dateString.split(" ");
                        if (!datePart) return "N/A";

                        const [day, month, year] = datePart.split("-");
                        if (!day || !month || !year) return "N/A";

                        // If no time part, return date only
                        if (!timePart) return `${day}-${month}-${year}`;

                        const [hour, minute] = timePart.split(":");
                        if (!hour || !minute) return `${day}-${month}-${year}`;

                        const dateObj = new Date(
                          year,
                          month - 1,
                          day,
                          hour,
                          minute
                        );
                        if (isNaN(dateObj.getTime())) return "N/A";

                        const hours = dateObj.getHours();
                        const minutes = dateObj
                          .getMinutes()
                          .toString()
                          .padStart(2, "0");
                        const ampm = hours >= 12 ? "PM" : "AM";
                        const formattedHour =
                          hours % 12 === 0 ? 12 : hours % 12;

                        return `${day}-${month}-${year} ${formattedHour}:${minutes} ${ampm}`;
                      } catch (err) {
                        return "N/A";
                      }
                    })()}
                  </span>
                </p>

                {userInfo?.startTime && userInfo?.endTime && (
                  <p className="">
                    Timing:{" "}
                    <span className="text-secondary fw-normal">
                      {userInfo?.startTime} to {userInfo?.endTime}{" "}
                      {userInfo?.timeZone
                        ? userInfo?.timeZone.split(" ")[0]
                        : ""}
                    </span>{" "}
                  </p>
                )}

                <p className="">
                  Job ID :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.jobUuid}
                  </span>{" "}
                </p>
                <p className="">
                  Validity :{" "}
                  <span className="text-secondary fw-normal">
                    {userInfo?.validity}
                  </span>{" "}
                </p>
                {userInfo.workType != "REMOTE" && (
                  <p className="">
                    Job Location :{" "}
                    <span className="text-secondary fw-normal">
                      {userInfo?.jobLocation || userInfo.workType}
                    </span>{" "}
                  </p>
                )}
                {/* <p className="">
    								Openings:{" "}
    								<span className="text-secondary fw-normal">
    									{userInfo?.noOfPosition || 'N/A'}
    								</span>{" "}
    							</p> */}
              </div>
            </div>

            <div className="vj_desc" style={{ whiteSpace: "pre-line" }}>
              <b>Job Description :</b>
              <p>{userInfo?.jobDescription}</p>
            </div>
            {/* <div className="vj_desc">
                                <b>Key Responsibilities :</b>
                                <li>Develop user interfaces for modern web applications using React.js</li>
                                <li>Build reusable components and front-end libraries for future use</li>
                                <li>Optimize components for maximum performance across a vast array of web-capable devices and browsers</li>
                                <li>Continuously discover, evaluate, and implement new technologies to maximize development efficiency</li>
                        </div> */}
            <>
              {userInfo?.jobAttachmentFile && (
                <p className="">
                  <a href={userInfo?.jobAttachmentFile} target="_blank">
                    <button
                      type="button"
                      style={{ width: "170px" }}
                      class="btn btn-outline-primary-custom"
                    >
                      View Assignment
                    </button>
                  </a>
                </p>
              )}
              {vendorid == userInfo?.vendorId &&
                userInfo?.jobsPostedStatus !== "ONHOLD" &&
                userInfo?.jobsPostedStatus !== "POSTLATER" && (
                  <Link to={`/apply-job-list/${userInfo?.jobId}`}>
                    <button
                      type="button"
                      style={{ width: "auto" }}
                      class="btn btn-outline-primary-custom"
                    >
                      Applied Candidate
                    </button>
                  </Link>
                )}
              {userInfo?.jobsPostedStatus === "ONHOLD" && (
                <p>
                  <button
                    onClick={() => navigate(`/post_job/${userInfo?.jobId}`)}
                    type="button"
                    style={{ width: "auto" }}
                    class="btn btn-outline-primary-custom"
                  >
                    Post Job
                  </button>
                </p>
              )}
            </>
          </div>
          <div className="vj_right card">
            <div className="vj_about custom_shadow p-4 rounded bg-white card-body">
              <div>
                <h6
                  className="mb-3"
                  style={{ fontSize: "1.5rem", textAlign: "center" }}
                >
                  About Us!
                </h6>
                <hr className="custom-divider mx-auto" />
              </div>

              <div className="about_company mt-4">
                <div className="d-flex flex-wrap align-items-center justify-content-center gap-3 mb-4">
                  <img
                    src={ebLogo}
                    alt="Company Logo"
                    className="img-fluid"
                    style={{
                      height: "50px",
                      width: "auto",
                      textAlign: "center",
                      objectFit: "contain",
                    }}
                  />
                  <p className="mb-0 fw-bold fs-5">Ebench Pvt. Ltd.</p>
                </div>

                <div className="about_info text-secondary">
                  <p className="mb-3">
                    <strong>AI That Understands Hiring:</strong> eBench uses
                    intelligent algorithms to match you with the right
                    candidates—fast, accurately, and with zero guesswork.
                  </p>
                  <p className="mb-3">
                    <strong>Vetted Professionals Only:</strong> Every candidate
                    is thoroughly assessed for skills, experience, and
                    fit—saving you time and ensuring quality.
                  </p>
                  <p className="mb-0">
                    <strong>All-in-One Hiring Platform:</strong> Post jobs,
                    manage candidates, schedule interviews, and onboard—all from
                    one intuitive dashboard.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobDetails;
